/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from "react";
import { InputLabel, MenuItem, Modal, Paper, Select, SelectChangeEvent } from "@mui/material";
import styled from "styled-components";

interface ConfigDevicesModalProps {
  open: boolean;
  devices: MediaDeviceInfo[];
  onClose: () => void;
  selectedMic: MediaDeviceInfo | undefined;
  selectedCamera: MediaDeviceInfo | undefined;
  changeSelectedMic: (device: MediaDeviceInfo | undefined) => void;
  changeSelectedCamera: (device: MediaDeviceInfo | undefined) => void;
  changeSelectedCameraWhitelabel: (device: any) => void;
}

export const ConfigDevicesModalWhitelabel = ({
  open,
  devices,
  onClose,
  selectedMic,
  selectedCamera,
  changeSelectedMic,
  changeSelectedCamera,
  changeSelectedCameraWhitelabel
}: ConfigDevicesModalProps) => {
  const handleChangeMic = React.useCallback(
    (e: SelectChangeEvent) => {
      const selected = e.target.value;
      if (selected === "") {
        return;
      }
      const device = devices.find((item) => item.deviceId === selected);
      changeSelectedMic(device);
    },
    [devices]
  );

  const handleChangeCamera = React.useCallback(
    (e: SelectChangeEvent) => {
      console.log('selected camera', e.target.value);
      const selected = e.target.value;
      if (selected === "") {
        return;
      }
      const device = devices.find((item) => item.deviceId === selected);
      console.log('device', device);
      changeSelectedCamera(device);
      changeSelectedCameraWhitelabel(device);
    },
    [devices]
  );

  return (
    <Modal open={open} disableEscapeKeyDown={true}>
      <Container>
        <Header>
          <Title>Selecionar dispositivo</Title>
        </Header>
        <Content>
          <SelectWrapper>
            <SelectLabel id={"camera-select"}>Câmera</SelectLabel>
            <CustomSelect
              labelId={"camera-select"}
              value={selectedCamera?.deviceId ?? ""}
              onChange={(e: SelectChangeEvent<any>) => handleChangeCamera(e)}
            >
              {devices
                .filter((device) => device.kind === "videoinput")
                .map((device, index) => (
                  <SelectItem key={device.deviceId} value={device.deviceId}>
                    {device.label ?? `Câmera ${index + 1}`}
                  </SelectItem>
                ))}
            </CustomSelect>
          </SelectWrapper>
          <SelectWrapper>
            <SelectLabel id={"mic-select"}>Microfone</SelectLabel>
            <CustomSelect
              labelId={"mic-select"}
              value={selectedMic?.deviceId ?? ""}
              onChange={(e: SelectChangeEvent<any>) => handleChangeMic(e)}
            >
              {devices
                .filter((device) => device.kind === "audioinput")
                .map((device, index) => (
                  <SelectItem key={device.deviceId} value={device.deviceId}>
                    {device.label ?? `Microfone ${index + 1}`}
                  </SelectItem>
                ))}
            </CustomSelect>
          </SelectWrapper>
        </Content>
        <Footer>
          <CloseButton onClick={onClose}>Fechar</CloseButton>
        </Footer>
      </Container>
    </Modal>
  );
};

const Container = styled(Paper)`
  display: flex;
  flex-direction: column;
  left: 50%;
  max-width: 90%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 450px;
`;

const Header = styled.div`
  align-items: center;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  justify-content: center;
  padding: 16px;
`;

const Title = styled.div`
  color: #4c5667;
  font-size: 18px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
  padding: 16px;
`;

const SelectWrapper = styled.div`
  width: 100%;
`;

const SelectLabel = styled(InputLabel)`
  && {
    font-family: "Versos", sans-serif !important;
    padding-left: 5px;
    color: black;
  }
`;

const CustomSelect = styled(Select)`
  && {
    background-color: white;
    box-shadow: 2px 2px 7px rgb(0 0 0 / 30%);
    width: 100%;
    outline: none;
    font-family: "Versos", sans-serif !important;
    text-overflow: ellipsis;
    overflow: hidden;

    .MuiSelect-select {
      font-size: 14px;
      padding: 10px 32px 10px 10px;
      color: #212529;
    }

    fieldset {
      border: none;
    }
  }
`;

const SelectItem = styled(MenuItem)`
  font-family: "Versos", sans-serif !important;
  color: #212529;
`;

const Footer = styled.div`
  align-items: center;
  border-top: 1px solid #e9ecef;
  display: flex;
  justify-content: flex-end;
  padding: 8px;
`;

const CloseButton = styled.button`
  background-color: rgb(226, 38, 38);
  border: none;
  border-radius: 4px;
  color: #ffffff;
  cursor: pointer;
  height: 38px;
  padding: 0 32px;
  transition: background-color 0.2s;

  :hover {
    background-color: rgb(206, 37, 37);
  }
`;